const Footer = () => {
  return (
    <footer className="bg-[#050505] text-gray-500 text-sm py-8 px-6 sm:px-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto text-center">
        <p>© {new Date().getFullYear()} Sakshi. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
